import React from "react";
import { Button } from "reactstrap";
import { enqueueSnackbar } from "notistack";
import Swal from "sweetalert2";

import { BRAND_BLUE } from "../constants/assetValuationConstants";

const AssetReviewFooter = ({
    selectedAsset,
    isBuildingCategory,
    savingEditAsset,
    handleSaveEditAsset,
    handleMarkEditAssetReviewNotCompleted,
    isIncompleteTab,
    isRemarkIssuesTab,
    unreviewAssetById,
    clearReviewRemarkIssueByAssetId,
    closeEditModal,
}) => {
    if (!selectedAsset || isBuildingCategory) return null;

    return (
        <>
            <Button color="primary" onClick={handleSaveEditAsset} disabled={savingEditAsset}>
                {savingEditAsset ? "Saving..." : "Mark as Reviewed"}
            </Button>
            <Button color="warning" onClick={handleMarkEditAssetReviewNotCompleted} disabled={savingEditAsset}>
                Mark to be Reviewed Later
            </Button>
            {isIncompleteTab && (
                <Button
                    color="secondary"
                    onClick={async () => {
                        const assetId = selectedAsset?.id;
                        if (!assetId) return;
                        const confirmed = await Swal.fire({
                            title: "Move to Unreviewed?",
                            text: "This will remove review-incomplete status and move the asset to Un Reviewed list.",
                            icon: "question",
                            showCancelButton: true,
                            confirmButtonText: "Move",
                            cancelButtonText: "Cancel",
                            confirmButtonColor: BRAND_BLUE,
                        });
                        if (!confirmed.isConfirmed) return;
                        try {
                            await unreviewAssetById(assetId);
                            closeEditModal();
                        } catch (error) {
                            console.error("Failed to move asset to unreviewed:", error);
                            enqueueSnackbar("Failed to move asset to unreviewed.", { variant: "error" });
                        }
                    }}
                    disabled={savingEditAsset}
                >
                    Move to Unreviewed
                </Button>
            )}
            {isRemarkIssuesTab && (
                <Button
                    color="info"
                    onClick={async () => {
                        const assetId = selectedAsset?.id;
                        if (!assetId) return;
                        const confirmed = await Swal.fire({
                            title: "Remove Remark Issue?",
                            text: "This will remove issue keywords and keep the asset under Review Incomplete.",
                            icon: "question",
                            showCancelButton: true,
                            confirmButtonText: "Remove Issue",
                            cancelButtonText: "Cancel",
                            confirmButtonColor: BRAND_BLUE,
                        });
                        if (!confirmed.isConfirmed) return;
                        try {
                            await clearReviewRemarkIssueByAssetId(assetId);
                            closeEditModal();
                        } catch (error) {
                            console.error("Failed to remove remark issue:", error);
                            enqueueSnackbar("Failed to remove remark issue.", { variant: "error" });
                        }
                    }}
                    disabled={savingEditAsset}
                >
                    Remove Remark Issue
                </Button>
            )}
        </>
    );
};

export default AssetReviewFooter;
